import React from 'react'
import APIManager from '../util/apiManager'
import LocalStorageManager from '../util/localStorageManager'
import Observable from '../helpers/observerable'

const localStorageManager = LocalStorageManager.getInstance()

// @ts-ignore
export const CameraContext = React.createContext()

const storeColumnList = [
    'isNightVision',
    'isAutoLowLight',
    'isPersonDetection',
    'enableDetection',
    'detectionMode',
    'sensitivity',
    'isPreview',
    'isAudio',
    'isGrantedMicrophonePermission',
    'selectedCamera',
    'selectedMicrophone',
    'videoRatio',
    'recordNativeResolution',
    'testVideo',
    'isLived',
    'globalInfereceInterval',
]

const syncedColumn = [
    'isNightVision',
    'isAutoLowLight',
    'isPersonDetection',
    'enableDetection',
    'detectionMode',
    'sensitivity',
    'isPreview',
    'isAudio',
    'videoRatio',
    'isGrantedCameraPermission',
]

const defaultState = {
    isNightVision: false,
    isAutoLowLight: false,
    isPersonDetection: false,
    isRecording: false,
    recordTime: '',

    enableDetection: false,
    detectionMode: 'motion',
    sensitivity: 2,

    isPreview: false,
    isAudio: true,
    isGrantedMicrophonePermission: false,
    isGrantedCameraPermission: false,
    selectedCamera: null,
    selectedMicrophone: null,

    isLived: false,

    mainCanvas: null,
    recordCanvas: null,
    liveStream: null,

    previewWidth: 0,
    previewHeight: 0,
    liveWidth: 0,
    liveHeight: 0,
    resolutionPreset: 0, // 0: auto, 1: basic, 2: standard, 3: HD

    isRelay: false,
    videoRatio: false,
    recordNativeResolution: false,
    testVideo: null,
    debugView: window.alfredTest2wsxsw2 ? true : false,
    dbFile: null,
    runPipeline: true,
    testImage: null,
    globalInfereceInterval: 300,

    error: null,
    settingRevision: 1,
}

export class CameraProvider extends React.Component {
    // @ts-ignore
    observable = ''

    constructor(props) {
        super(props)
        this.observable = new Observable()
        // @ts-ignore
        this.state = {
            ...defaultState,
            // test-only
            isPersonDetectionBox: window.alfredTest2wsxsw2,
            isPaintSize: window.alfredTest2wsxsw2,

            mutations: {
                updateStatus: this.updateStatus.bind(this),
                resetState: this.resetState.bind(this),
            },
            observable: this.observable,
        }

        const storeCameraSettings = {}
        storeColumnList.forEach((key) => {
            storeCameraSettings[key] = localStorageManager.cameraSettings[key]
        })
        this.state = Object.assign({}, this.state, storeCameraSettings)
        this.apiManager = APIManager.getInstance()
    }

    resetState() {
        this.setState({
            ...defaultState,
            // test-only
            isPersonDetectionBox: window.alfredTest2wsxsw2,
            isPaintSize: window.alfredTest2wsxsw2,
        })
    }

    updateStatus(updateObject) {
        // Prevent to update device every times
        let shouldDeviceUpdated = false
        for (const key of ['enableDetection', 'sensitivity', 'detectionMode']) {
            if (updateObject[key] !== undefined) {
                shouldDeviceUpdated = true
                break
            }
        }
        for (const key of syncedColumn) {
            if (updateObject[key] !== undefined) {
                updateObject.settingRevision = this.state.settingRevision + 1
                // this.observable.notify({ key: 'updateStatus' })
                break
            }
        }
        this.setState(updateObject, () =>
            this.setSettingsCache(shouldDeviceUpdated)
        )
    }

    setSettingsCache = (shouldDeviceUpdated) => {
        const updateObj = {}
        storeColumnList.forEach((key) => {
            updateObj[key] = this.state[key]
        })
        localStorageManager.setSettingsCache({
            type: 'camera',
            updateObj,
        })
        if (shouldDeviceUpdated) {
            const data = {
                motion: updateObj['enableDetection'],
                sensitivity: updateObj['sensitivity'],
                detector: updateObj['enableDetection']
                    ? updateObj['detectionMode'] === 'person'
                        ? 3
                        : 2
                    : 0, // md is off = 0, person = 3, motion = 2
            }
            this.apiManager.updateDevice(data)
        }
    }

    render() {
        return (
            <CameraContext.Provider value={this.state}>
                {this.props.children}
            </CameraContext.Provider>
        )
    }
}

// @ts-ignore
export const WithCameraContext = (Component) => (props) => (
    <CameraContext.Consumer>
        {
            // @ts-ignore
            (context) => <Component cameraContext={context} {...props} />
        }
    </CameraContext.Consumer>
)
